import React from 'react'
import { Navigate, useLocation, matchPath } from 'react-router-dom'
import { useAppSelector } from 'hooks/redux-hooks'
import { isFSRUser, isFSRAllowedPath } from 'utils/fsrUtil'
import PermissionDenied from 'pages/PermissionDenied/PermissionDenied'
import routes from 'routes'
import { Pages } from 'routes/types'
import { shouldAskForSignature } from 'utils/signatureUtil'

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, tokenHeader, userSignUrl, userSignatureChecked } = useAppSelector((state) => state.auth)
  const location = useLocation()

  if (!isLoggedIn) return <Navigate to='/login' />

  const captureSignaturePath = routes[Pages.CaptureSignature].path
  const isCaptureSignatureRoute = matchPath(captureSignaturePath, location.pathname)
  if (
    shouldAskForSignature(tokenHeader) &&
    userSignatureChecked &&
    !userSignUrl &&
    !isCaptureSignatureRoute
  ) {
    return <Navigate to={captureSignaturePath} replace />
  }

  // Only show Permission Denied for FSR users on existing routes that are not allowed
  if (isFSRUser() && !isFSRAllowedPath(location.pathname)) {
    const routeExists = Object.values(routes).some(
      (route) => route.path !== '*' && matchPath(route.path, location.pathname)
    )
    if (routeExists) {
      return <PermissionDenied />
    }
  }

  return children
}

export default PrivateRoute
